var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mt-4" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("plain-text-control", {
          attrs: { title: "Organisation.Personnel.Title", required: true }
        }),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass: "table tablerow",
            attrs: {
              id: "",
              "aria-label": _vm.$t("Organisation.Personnel.Title")
            }
          },
          [
            _c("thead", [
              _c("tr", [
                _c(
                  "th",
                  {
                    staticClass: "w-70",
                    attrs: { id: "Organisation.Personnel_People" }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("Organisation.Personnel.ColumnHeader1"))
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "w-15 right",
                    attrs: { id: "Organisation.Personnel_Number" }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("Organisation.Personnel.ColumnHeader2"))
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "w-15 right",
                    attrs: { id: "Organisation.Personnel_Years" }
                  },
                  [
                    _c(
                      "plain-text-control",
                      {
                        attrs: {
                          noMargin: "",
                          title: "Organisation.Personnel.ColumnHeader3"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "mr-1",
                            attrs: { slot: "content" },
                            slot: "content"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Organisation.Personnel.ColumnHeader3")
                              )
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", { staticClass: "aidapplications-main-row border-0" }, [
                _c(
                  "th",
                  { staticClass: "row-heading" },
                  [
                    _c("plain-text-control", {
                      attrs: {
                        title: "Organisation.Personnel.RowHeader1",
                        noMargin: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "input-cell" },
                  [
                    _c("numeric-input-control", {
                      attrs: {
                        disabled: _vm.isReadOnly,
                        placeholderKey: "EnterValue",
                        required: true,
                        labelledBy: "Organisation.Personnel_Number"
                      },
                      model: {
                        value: _vm.report.personnel.employee_Count,
                        callback: function($$v) {
                          _vm.$set(_vm.report.personnel, "employee_Count", $$v)
                        },
                        expression: "report.personnel.employee_Count"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "input-cell" },
                  [
                    _c("decimal-input-control", {
                      attrs: {
                        disabled: _vm.isReadOnly,
                        placeholderKey: "EnterValue",
                        required: true,
                        labelledBy: "Organisation.Personnel_Years"
                      },
                      model: {
                        value: _vm.report.personnel.employee_PersonYears,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.report.personnel,
                            "employee_PersonYears",
                            $$v
                          )
                        },
                        expression: "report.personnel.employee_PersonYears"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "aidapplications-main-row border-0" }, [
                _c(
                  "th",
                  { staticClass: "row-heading" },
                  [
                    _c("plain-text-control", {
                      attrs: {
                        title: "Organisation.Personnel.RowHeader2",
                        noMargin: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "input-cell" },
                  [
                    _c("numeric-input-control", {
                      attrs: {
                        disabled: _vm.isReadOnly,
                        placeholderKey: "EnterValue",
                        required: true,
                        labelledBy: "Organisation.Personnel_Number"
                      },
                      model: {
                        value: _vm.report.personnel.volunteer_Count,
                        callback: function($$v) {
                          _vm.$set(_vm.report.personnel, "volunteer_Count", $$v)
                        },
                        expression: "report.personnel.volunteer_Count"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "disabled" })
              ])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }